import React from "react";
import Header from "../Header/header"
import { Grid, Typography, Paper, Button, ListItem, ListItemText } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Album2 from "../album/albumdiagnosis2"
import Footer from "../Footer/Footer"
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import StartButton from "../Buttons/StartButton";
import Card_expertise from "./card_expertise";
import Card_expertise2 from "./card_expertise2";
import Card_expertise3 from "./card_expertise3";
import Card_expertise4 from "./card_expertise4";
import CE_mark2 from "../images/CE_mark2.png"
import danish_patient_safety_authority from "../images/danish_patient_safety_authority.png"
import gdpr from "../images/gdpr.png"

const useStyles = makeStyles((theme) => ({
    icon: {
      marginRight: theme.spacing(2),
    },
    heroContent: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
      marginTop: theme.spacing(4),
    },
    cardGrid: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    card: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    cardMedia: {
      paddingTop: '56.25%', // 16:9
    },
    cardContent: {
      flexGrow: 1,
    },
    footer: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(6),
    },
  }));

const Our_expertise = () => {
    const classes = useStyles();
    return (
    <Grid container xs={12} style={{backgroundColor: "#eaeaea"}}>
        <Header/>
        <Grid xs={12} style={{backgroundColor: "#002D55", height: 250}} />
        <Grid container justify="center" style={{backgroundColor: "#eaeaea", marginTop: 20}}>
            <Grid container justify="center" style={{backgroundColor: "#eaeaea", marginTop: 0}}>
                <Paper item xs={12} style={{width: "70%", justify: "center", margin: 20, padding: 20}}>
                    <Typography style={{color: "#002D55"}}>
                    <h1 style={{color: "#002D55"}}>About Virtus Physio</h1>
                    <p>
                    We are an ambitious start-up that is headquartered in Copenhagen, Denmark. <br/>A country that is consistently ranked as having one of the best healthcare systems in the world. <br/>
                    Health is a very important issue for us to address in today's society and we aim to tackle this issue head-on by consistently offer high-quality healthcare service <br />on a virtual platform.
                    <br/><br/>At Virtus, we understand the need for change & innovation in healthcare and we are therefore proud to announce our first Virtual Physiotherapist <br />supported by A.I. technology to offer you a better, convenient and affordable healthcare.
                    <br/><br/>We believe that by offering our service virtually that patients will experience a higher degree of self-empowerment and control of their individual health challenges.
                    <br/>Virtus is Latin for the English word 'virtue', which can translate into: "of high standards", and is at the same time referring to the word 'virtual' and the digitalization of healthcare.
                    <br/>By such references, we want to offer high-quality virtual physiotherapy services with virtue on a virtual platform.
                    <br/>We want to offer convenient, time-saving, affordable, accessible and cost-effective services & solutions based on the best & latest research <br />for evidence-based practice to the benefit of our clients & patients!
                    <br/><br/>All we ask is that you are up for taking an active part in your health, then we will gladly help you on your journet back to your best!
                    </p>
                    <h1>Registered medical device in the EU & UK.</h1>
                    <p >
                    Our product and service lives up the standards of the:
                    "Conformité Européene" CE mark, which is an international certification and security standard for medical devices and products within the EU.
                    <p />We are also registered within the The Health and Care Professions Council (HCPC) in the UK and approved by a medical panel in the Danish Medicine Agency.</p>
                    <h1 style={{color: "#002D55"}}>Our expertise</h1>
                    <p >With our expertise within physiotherapy we promote, maintain, or restore health through physical examination, diagnosis, prognosis, <br />patient education, physical intervention, rehabilitation, disease prevention and health promotion, through a digital service product. <br /></p>
                    
                    <h1 style={{color: "#002D55"}}>Who can we help</h1>
                    <p >We can help with most cases of pain, injuries and reduced function, whether it be in relation to sports-related pain & injuries, <br />work-related pain, general muscle and joint pain and rehabilitation after some selected surgeries.<br /><br />
                    We help by first evaluating your symptoms and individual needs, and then match you with appropriate advice,<br /> education about your pain and physiotherapeutic exercises structured in a 6 week program, designed to get you back to your best.<br /></p>
                    <h1 style={{color: "#002D55"}}>Who we can't help</h1>
                    <p >Our algorithm is designed to identify those symptoms that are suitable for virtual physiotherapy services<br /> and those symptoms that require to be seen by a doctor in person. <br /><br />
                    However even if your symptoms are suitable for virtual physiotherapy services, it also requires a few things such as internet access, some technology (computer, smartphone, tablet) and <br />an acceptance or a preference of a virtual physiotherapy service.
                    </p>
                    </Typography>
                </Paper>
                <Album2 />
            </Grid>
        </Grid>
        <Grid xs={12} container justify="center" justifyContent="center">
            <Footer />
        </Grid>
    </Grid>
    );
};

export default Our_expertise;

